import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3ddeb605"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-price-wrap" }
const _hoisted_2 = { class: "current-price" }
const _hoisted_3 = {
  key: 0,
  class: "origin-price"
}
const _hoisted_4 = { class: "unit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ServiceEnum = _resolveComponent("ServiceEnum")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    width: "100%",
    data: _ctx.serviceMerge,
    "tooltip-effect": "light",
    "max-height": 400,
    "empty-text": _ctx.$t('common.noData')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        "class-name": "cm-ui-pl10",
        label: _ctx.t('subscribeDetails.tableColIndex'),
        "min-width": "10%"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.$index + 1), 1)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_table_column, {
        label: _ctx.t('subscribeDetails.tableColComboOrServiceName'),
        "min-width": "20%"
      }, {
        default: _withCtx((scope) => [
          (scope.row.child_price?.length)
            ? (_openBlock(), _createBlock(_component_ServiceEnum, {
                key: 0,
                group: scope.row.title
              }, null, 8, ["group"]))
            : (_openBlock(), _createBlock(_component_ServiceEnum, {
                key: 1,
                services: [scope.row.title]
              }, null, 8, ["services"]))
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_table_column, {
        label: _ctx.t('subscribeDetails.tableColIncludedServices'),
        "min-width": "50%"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.child_price?.length ? _ctx.getGroupServicesName(scope.row) : '--'), 1)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_table_column, {
        label: _ctx.t('subscribeDetails.tableColDiscountPrice'),
        "min-width": "20%"
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, [
              _createElementVNode("em", null, _toDisplayString(_ctx.t('subscribeDetails.currencyYuanSymbol')), 1),
              _createTextVNode(_toDisplayString(scope.row.unit_price / 100), 1)
            ]),
            (scope.row.unit_price !== scope.row.origin_unit_price)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.t('subscribeDetails.currencyYuanSymbol')) + _toDisplayString(scope.row.origin_unit_price / 100), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t('buyMore.unitPerTerminalPerYear')), 1)
          ])
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _: 1
  }, 8, ["data", "empty-text"]))
}